import { productMap } from "./product";

export const paginatedPartogramRecord = {
	results: {
		product: productMap,
		examiner: {
			nome: "name",
		},
	},
};
